import {useEffect, useRef, useState} from "react";

export default function Description({ html }) {
  const descRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [html]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (!descRef.current) return setCanExpand(false);
      const fontSize = 14, lineHeight = 1.6, maxLines = 4;
      const maxHeight = maxLines * lineHeight * fontSize;
      setCanExpand(descRef.current.scrollHeight > maxHeight + 1);
    }, 50);
    return () => clearTimeout(id);
  }, [html]);

  return (
    <div className="mt-3 p-3 video-description" style={{backgroundColor:"rgba(0,0,0,0.05)", borderRadius:4}}>
      <div
        ref={descRef}
        className={expanded ? "" : "desc-collapsed"}
        dangerouslySetInnerHTML={{ __html: html || "" }}
      />
      {canExpand && html && (
        <div className="mt-2">
          <button type="button" className="show-more-btn" onClick={() => setExpanded(v => !v)} aria-expanded={expanded}>
            {expanded ? "Show less" : "Show more"}
          </button>
        </div>
      )}
    </div>
  );
}